module.exports = __webpack_public_path__ + "media/assets/icons/treasure-chest-white-03f7e020bcb3e8b02077d50886570442.svg";